"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MessageTypes;
(function (MessageTypes) {
    MessageTypes["Error"] = "ERROR";
    MessageTypes["Warning"] = "WARNING";
    MessageTypes["Success"] = "SUCCESS";
    MessageTypes["Info"] = "INFO";
    MessageTypes["Apocalypse"] = "APOCALYPSE";
})(MessageTypes = exports.MessageTypes || (exports.MessageTypes = {}));
// Redux store types
exports.ADD_MESSAGE = 'REDUX_FLASH_MESSAGE.ADD_FLASH_MESSAGE';
exports.REMOVE_MESSAGE = 'REDUX_FLASH_MESSAGE.REMOVE_FLASH_MESSAGE';
